"use client";

import React from "react";
import ModalFormExample from "@/examples/modals/ModalFormExample";

export default function ModalFormPage() {
  return (
    <div className="container mx-auto p-6">
      <ModalFormExample />
    </div>
  );
}
